(function (Drupal, $,once) {
  Drupal.behaviors.scrollFix = {
    attach: function (context) {
      "use strict";

      $(once("form-processed","#views-exposed-form-stores-stores")
        ).addClass("form-processed")
        .each(function () {

          var filterClicked = false;

          $("#views-exposed-form-stores-stores .form-item--radio .form-item label").each(function () {
            $(this).click(function () {
              filterClicked = true;
            });
          });

          $('.form-item__dropdown select').on('change', function(){
            filterClicked = true;
          })

          $(document, context).ajaxSuccess(function () {
            if (filterClicked) {
              $([document.documentElement, document.body]).animate(
                {
                  scrollTop: $("#store-listing-container").offset().top - 100,
                },
                300
              );

              filterClicked = false;
            }
          });

        });
    },
  };
})(Drupal, jQuery,once);
